<template><section><template>
<h3>卡片</h3>
<div class="bs-docs-section">
<div class="bs-example">
  <n3-card style="padding:20px">
    <p>xxxxx</p>
    <p>xxxxx</p>
    <p>xxxxx</p>
  </n3-card> 
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-card</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"padding:20px"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>xxxxx<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>xxxxx<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>xxxxx<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-card</span>&gt;</span> 
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>hover</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">true</code></td>
<td>是否hover效果</td>
</tr>
</tbody>
</table>
</div>
</template>
</section></template>

<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>


// WEBPACK FOOTER //
// n3CardDocs.md?28d15e6c